import { Component, Input } from '@angular/core';
import { getHomeFullPath } from '@app/routes-definitions';

@Component({
    selector: 'app-logo',
    templateUrl: './app-logo.component.html',
    standalone: false
})
export class AppLogoComponent {
	@Input() inHeader: boolean = true;
	@Input() isBO: boolean = false;
	homePath: string = getHomeFullPath();
}
